import React, { useState, useRef, useEffect, useContext } from 'react';
import "./payments.css"
import ErrorComponent from "../../components/UI/Error/ErrorComponent"
import { observer } from "mobx-react-lite";
import axios from 'axios';

import { Context } from "../../index";
import { useNavigate } from "react-router-dom"
import SpinPage from '../../components/UI/Spin/Spin';
import Succses from "../../components/UI/Notification/Succses"


import PaysService from "../../service/PaysService"
import Footer from "../../components/Footer/Footer";
import { fillTextPage } from "../../Utils/FillTextPage";
import UserService from "../../service/UserService";
import stylesSetting from "../Settings/settings.module.css"
import Bonuses from "../../components/Bonuses/Bonuses";
import { MODE, NAME_SERVER } from '../../Utils/NAME_HOST';
import { ConfigProvider, Select, Spin } from 'antd';
import Dropdown_methods from '../../components/UI/Dropdown_methods/Dropdown_methods';
import InfoWagering from './components/InfoWagering/InfoWagering';
import ExpayService from '../../service/ExpayService';
import CopyToClipboard from 'react-copy-to-clipboard';
import Switcher from '../../components/UI/Switcher/Switcher';
import { el } from 'date-fns/locale';

const Deposit = () => {
    const { store } = useContext(Context);
    const [amount, setAmount] = useState(0);

    const [dep, setDep] = useState(true);
    const [purse_number, setPurse_number] = useState("")
    const [choice_payment, setChoice_payment] = useState("")
    const [payin_methods, setPayin_methods] = useState([])
    const [payin_methods_crypto, setPayin_methods_crypto] = useState([])
    const [payout_methods, setPayout_methods] = useState([])
    const [stateListBanks, setStateListBanks] = useState(false);
    const [stateListMobile, setStateListMobile] = useState(false);
    const [info_wagering, setInfoWagering] = useState(false);

    const [loadingCryptoForm, setLoadingCryptoForm] = useState(false);



    const [history_open, setHistory_open] = useState(false)
    const [history_payinWar_loading, setHistory_payinWar_loading] = useState([])
    const [history_payinWar_cancel, setHistory_payinWar_cancel] = useState([])
    const [disable_btn, setDisable_btn] = useState(false);
    const [history_payinSuccses, setHistory_payinSuccses] = useState([])
    const [valueTypePayIn, setValueTypePayIn] = useState("Фиат")
    const [messageSuccses, setMessageSuccses] = useState("")
    const [statusSuccsesChange, setStatusSuccsesChange] = useState(false);
    const [stateText, setStateText] = useState(true)
    const [payInCardCrypto, setPayInCardCrypto] = useState("")
    const [promocode, setPromocode] = useState("");
    const [loadDate, setloadDate] = useState(false)
    const [loadingHistory, setLoadingHistory] = useState(false);
    const [client_name, setClient_name] = useState("")
    const [client_email, setClient_email] = useState("")
    const [essential_key, setEssential_key] = useState("")
    const [card_number, set_card_number] = useState("")
    const [cryptoData, setCryptoData] = useState({})
    const [cryptoData_current, setCryptoData_current] = useState({})

    const [graphPayin_methods, setgraphPayin_methods] = useState({})
    const [graphPayin_methods_crypto, setgraphPayin_methods_crypto] = useState({})
    const [graphPayout_methods, setgraphPayout_methods] = useState({})
    const [komm, setKomm] = useState(0)
    const [limits, setLimits] = useState("")
    const mobile_config = [{ label: "МТС", value: 1 }, { label: "Мегафон", value: 2 }, { label: "Билайн", value: 3 }]

    const [waitTime, setWaitTime] = useState(0)
    const [error, setError] = useState("")
    const [statusErrorChange, setStatusErrorChange] = useState(false);

    const [statusDepButton, setStatusDepButton] = useState(false);


    const [variant_buttons, setVariant_buttons] = useState("dep")

    const [variant_buttons_history, setVariant_buttons_history] = useState("dep")
    const navigate = useNavigate();
    const [authChecked, setAuthChecked] = useState(false)
    const [sbp_list, setSbp_list] = useState([])
    const [choice_sbp, setChoice_sbp] = useState("")
    const [choice_mobile, setChoice_mobile] = useState("")

    const [choice_sbpName, setChoice_sbpName] = useState("")
    const [choice_mobileName, setChoice_mobileName] = useState("")

    const [graph_sbp, setGraph_sbp] = useState([])
    const [bank_id, setBank_id] = useState("")
    const graph_naming = {
        "email": client_email,
        "name": client_name,
        "number": essential_key,
        "card_number": card_number,
        "promocode": promocode
    }

    const [inputs_payin, setInputs_payin] = useState([{
        _placeholder: "inputs_payin1",
        state: setAmount
    }, { _placeholder: "inputs_payin2", state: setPromocode, _dop_placeholder: "inputs_payin3" }])
    const [inputs_payout, setInputs_payout] = useState([{
        _placeholder: "inputs_payout1",
        state: setPurse_number
    }, { _placeholder: "inputs_payout2", state: setAmount }])
    function get_data_lists(input_payout, id) {

        const data_dropdowns = {
            "sbp": <>
                <div className='input-holder pays active' onClick={() => setStateListBanks(true)} style={{ color: "white", display: "flex", justifyContent: "left", alignItems: "center", paddingLeft: "17px", fontSize: "15px", cursor: "pointer", fontWeight: "400", fontFamily: "Popins,sans-serif" }}>{choice_sbpName ? choice_sbpName : store.dataLang[input_payout._placeholder] ? store.dataLang[input_payout._placeholder] : input_payout._placeholder}</div>
                <Dropdown_methods setValueId={setChoice_sbp} setValueName={setChoice_sbpName} state={stateListBanks} items={graph_sbp} setState={setStateListBanks} /></>,
            "mobile": <><div className='input-holder pays active' onClick={() => setStateListMobile(true)} style={{ color: "white", display: "flex", justifyContent: "left", alignItems: "center", paddingLeft: "17px", fontSize: "15px", cursor: "pointer", fontWeight: "400", fontFamily: "Popins,sans-serif" }}>{choice_mobileName ? choice_mobileName : store.dataLang[input_payout._placeholder] ? store.dataLang[input_payout._placeholder] : input_payout._placeholder}</div>
                <Dropdown_methods setValueId={setChoice_mobile} setValueName={setChoice_mobileName} state={stateListMobile} items={mobile_config} setState={setStateListMobile} /></>
        }
        return data_dropdowns[id]
    }
    function formatCurrency(amount) {
        const currency = 'RUB';

        const formatter = new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: currency,
        });

        const formattedAmount = formatter.format(amount);

        return formattedAmount.replace(",00", '')
    }

    async function startText() {
        try {
            await fillTextPage("deposit", store, setStateText)

        } catch (e) {
            console.error(e)

        }
    }


    useEffect(() => {
        startText();


    }, [])
    useEffect(() => {
        if (store.user.id) {
            getVerif();
        }
    }, [store.user.id])
    useEffect(() => {
        if (variant_buttons === "dep" || variant_buttons === "back") {
            getVerif();
        }
    }, [variant_buttons])
    useEffect(() => {

        if (error.length > 0) {
            store.add_message(error, ErrorComponent)
        }
    }, [statusErrorChange]);
    useEffect(() => {

        if (messageSuccses.length > 0) {
            store.add_message(messageSuccses, Succses)
        }
    }, [statusSuccsesChange]);
    useEffect(() => {
        if (store.state_bonus) {
            setVariant_buttons("bonus")
        }
    }, [store.state_bonus]);
    useEffect(() => {
        if (store.isAuth) {
            setAuthChecked(true);


        }

    }, [store.isAuth])
    useEffect(() => {
        if (!store.isLoading) {
            store.setIsLoadingComponent(false)

        }
    }, [store.isLoading]);
    useEffect(() => {
        if (variant_buttons === "history") {
            if (variant_buttons_history === "dep") {
                getHistoryPayIn()

            } else {
                getHistoryPayOut()
            }
        }
    }, [variant_buttons])

    async function getHistoryPayOut() {
        try {

            setLoadingHistory(true)
            const response = await PaysService.getHistoryPayOut();
            const fethes_result = response.data;
            const fk_inf = fethes_result.fk_inf.map(item => {
                // В item.id должно быть новое значение
                return {
                    ...item, // Копируем все остальные свойства из исходного объекта
                    id: item.id + "F" // Здесь должно быть новое значение
                };
            });
            const payport_inf = fethes_result.payport_inf.map(item => {
                // В item.id должно быть новое значение
                return {
                    ...item, // Копируем все остальные свойства из исходного объекта
                    id: item.id + "P" // Здесь должно быть новое значение
                };
            });
            const expay_inf = fethes_result.expay_inf.map(item => {
                // В item.id должно быть новое значение
                return {
                    date_create: item.createdAt,
                    ...item, // Копируем все остальные свойства из исходного объекта
                    id: item.id + "E" // Здесь должно быть новое значение
                };
            })


            const loading_fk_inf = fk_inf.filter(item => item.status === 2)
            const cancel_fk_inf = fk_inf.filter(item => item.status > 2)
            const loading_payport_inf = payport_inf.filter(item => item.status === 2);
            const cancel_payport_inf = payport_inf.filter(item => item.status > 2);
            const loading_expay_inf = expay_inf.filter(item => item.status === "ACCEPTED");
            const cancel_expay_inf = expay_inf.filter(item => item.status === "ERROR");


            const massive_war_loading = [...loading_fk_inf, ...loading_payport_inf, ...loading_expay_inf];
            const massive_war_cancel = [...cancel_fk_inf, ...cancel_payport_inf, ...cancel_expay_inf]


            setHistory_payinWar_loading(massive_war_loading);
            setHistory_payinWar_cancel(massive_war_cancel);

            setHistory_payinSuccses([...fethes_result.succses])
        } catch (e) {
            setError("error1")
            setStatusErrorChange(!statusErrorChange)

        } finally {
            setLoadingHistory(false)
        }

    }

    async function getHistoryPayIn() {
        try {

            setLoadingHistory(true)
            const response = await PaysService.getHistoryPayIn();
            const fethes_result = response.data;
            const fk_inf = fethes_result.fk_inf.map(item => {
                // В item.id должно быть новое значение
                return {
                    ...item, // Копируем все остальные свойства из исходного объекта
                    id: item.id + "F" // Здесь должно быть новое значение
                };
            });
            const payport_inf = fethes_result.payport_inf.map(item => {
                // В item.id должно быть новое значение
                return {
                    ...item, // Копируем все остальные свойства из исходного объекта
                    id: item.id + "P" // Здесь должно быть новое значение
                };
            });
            const expay_inf = fethes_result.expay_inf.map(item => {
                // В item.id должно быть новое значение
                return {
                    date_create: item.createdAt,
                    ...item, // Копируем все остальные свойства из исходного объекта
                    id: item.id + "E" // Здесь должно быть новое значение
                };
            })
            const loading_fk_inf = fk_inf.filter(item => item.status === 0)
            const cancel_fk_inf = fk_inf.filter(item => item.status === -1);

            const loading_payport_inf = payport_inf.filter(item => item.status === 0);
            const cancel_payport_inf = payport_inf.filter(item => item.status === -1);
            const loading_expay_inf = expay_inf.filter(item => item.status === "ACCEPTED");
            const cancel_expay_inf = expay_inf.filter(item => item.status === "ERROR");

            const massive_war_loading = [...loading_fk_inf, ...loading_payport_inf, ...loading_expay_inf];
            const massive_war_cancel = [...cancel_fk_inf, ...cancel_payport_inf, ...cancel_expay_inf]

            setHistory_payinWar_loading(massive_war_loading);
            setHistory_payinWar_cancel(massive_war_cancel);

            setHistory_payinSuccses([...fethes_result.succses])
        } catch (e) {
            setError("error1")
            setStatusErrorChange(!statusErrorChange)

        } finally {
            setLoadingHistory(false)
        }


    }

    async function getAllPayMethods() {

        const prom = await PaysService.getAllPayInMethods()
        if (prom.data.redirect) {
            navigate(prom.data.redirect)
        }
        if (prom.data.status === 1) {
            const met = prom.data.payin_methods_fiat
            const met_crypto = prom.data.payin_methods_crypto

            let graph = {}
            let graph_crypto = {};
            const grr = {}
            setPayin_methods(met)
            setPayin_methods_crypto(met_crypto)
            setCryptoData(prom.data.cryptoData)
            console.log(met, met_crypto)
            setSbp_list(prom.data.sbp_list)
            let list_spbs_methods = []
            for (let spb_bank of prom.data.sbp_list) {
                list_spbs_methods.push({ label: spb_bank.name, value: spb_bank.bank_id })

            }
            setGraph_sbp(list_spbs_methods)
            for (let mm of met) {
                graph[mm.name] = mm
            }
            for (let mm of met_crypto) {
                graph_crypto[mm.name] = mm;

            }
            setgraphPayin_methods_crypto(graph_crypto)
            console.log(graph_crypto)

            setgraphPayin_methods(graph)
            const out = prom.data.payout_methods
            graph = {}

            setPayout_methods(out)
            for (let mm of out) {
                graph[mm.name] = mm
            }
            setgraphPayout_methods(graph)
            setInfoWagering(prom.data.data_wagering);

            const inf_payment = prom.data.information_paymenets

            if (inf_payment) {
                setClient_name(inf_payment.name)
                setClient_email(inf_payment.email)
                setEssential_key(inf_payment.purse_number)
                if (inf_payment.card_number !== 0) {
                    set_card_number(inf_payment.card_number)

                }
                setPromocode(inf_payment.promocode)
            }
            setloadDate(true)



        } else {
            setError("error1")
            setStatusErrorChange(!statusErrorChange)

        }

    }

    async function fetch_fk() {
        try {


            const response = await axios.post("https://snake.money/freekassa/fk_create_payin.php", {
                method: choice_payment,
                amount,
                user_id: store.user.id,
                promocode
            })
            if (response.data) {
                if (response.data === "error_bonus_code") {
                    setStatusDepButton(false)
                    setError("error9")
                    setStatusErrorChange(!statusErrorChange)


                } else {
                    if (response.data.error) {
                        store.add_message(response.data.error, ErrorComponent)


                    }
                    else {


                        if (!response.data.location) {
                            store.add_message("error1", ErrorComponent)
                        }
                        else {
                            window.location.replace(response.data.location)

                        }
                    }
                    setStatusDepButton(false)

                    // window.location.replace(response.data)

                }

            }
        }
        catch (e) {
            setStatusDepButton(false)
            setError("error1")
            setStatusErrorChange(!statusErrorChange)


        }

    }

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Добавляем плавную анимацию прокрутки
        });
    }
    async function fetch_expay(token) {
        try {
            const response = await ExpayService.create_invoice(token, amount);
            const data = response.data
            if (data.status === 1) {

                window.location.replace(data.link)
                setStatusDepButton(false)

            }
            else {
                store.add_message(data.err ? data.err : "error1", ErrorComponent)
                setStatusDepButton(false)

            }

        }
        catch (e) {
            console.log(e);
            store.add_message("error1", ErrorComponent)
            setStatusDepButton(false)


        }
    }
    async function fetch_back_expay() {
        try {

            const response = await ExpayService.create_payout(choice_payment, purse_number, Number(amount), choice_sbpName)
            const data = response.data;
            if (data.status === 1) {
                store.user.balance -= Number(amount);
                setDisable_btn(true)

                setTimeout(() => {
                    setVariant_buttons("history")
                    setDisable_btn(false)
                    setVariant_buttons_history("back")


                }, 2000)

                store.add_message("Ваша заявка успешно создана.", Succses)
            }

            if (data.status === 0) {
                store.add_message(data.err, ErrorComponent)
            }

        }
        catch (e) {
            console.log(e)
            store.add_message("error1", ErrorComponent)
        }
    }
    async function fetch_back() {
        try {


            let response = null

            if (choice_payment === "fk_sbp") {

                response = await axios.post("https://snake.money/payout/payout.php", {
                    method: choice_payment,
                    amount,
                    user_id: store.user.id,
                    purse_number,
                    bank_id: choice_sbp,

                })
                // response={}

                if (response.status === 200 && response.data === "fk_ok_83") {
                    // scrollToTop()
                    setDisable_btn(true)

                    setTimeout(() => {
                        setVariant_buttons("history")
                        setDisable_btn(false)
                        setVariant_buttons_history("back")


                    }, 3000)
                    setStatusSuccsesChange(!statusSuccsesChange)
                    return setMessageSuccses("Ваша заявка успешно создана.")

                }

            } else {


                response = await axios.post("https://snake.money/payout/payout.php", {
                    method: choice_payment,
                    amount,
                    user_id: store.user.id,
                    purse_number,
                    mobile_id: choice_mobile
                })
            }
            if (response.status === 200 && response.data === "Выводы запрещены!") {
                setError("error10")
                setStatusErrorChange(!statusErrorChange)

            }

            //
            if (response.status === 200) {
                if (!response.data.url) {
                    store.add_message(response.data, ErrorComponent)
                }
                if (response.data.url) {
                    window.location.replace(response.data.url)
                }
                if (response.data === "fk_ok_83") {
                    setDisable_btn(true)
                    // scrollToTop()
                    setTimeout(() => {

                        setVariant_buttons("history")
                        setDisable_btn(false)

                        setVariant_buttons_history("back")

                    }, 3000)
                    setStatusSuccsesChange(!statusSuccsesChange)

                    return setMessageSuccses("Ваша заявка успешно создана.")


                }
            } else {
                // scrollToTop()

                setError("error1")
                setStatusErrorChange(!statusErrorChange)


            }
        } catch (e) {
            scrollToTop()

            setError("error1")
            setStatusErrorChange(!statusErrorChange)

        }
    }

    async function fetch_payport() {
        try {
            const essential_key_result = choice_payment === "by_mobile" ? essential_key : card_number
            const response = await axios.post("https://snake.money/payport/real/payin_create.php", {
                method: choice_payment,
                amount,
                client_name,
                user_id: store.user.id,
                client_email,
                essential_key: essential_key_result,
                promocode
            })
            if (response.data === "error_bonus_code") {
                setStatusDepButton(false);
                setError("error9")
                setStatusErrorChange(!statusErrorChange)

            }
            if (response.data.url) {
                window.location.replace(response.data.url)
            }

        } catch (e) {
            setStatusDepButton(false)
            setError("error1")
            setStatusErrorChange(!statusErrorChange)


        }


    }

    useEffect(() => {

        getAllPayMethods()

    }, [])
    useEffect(() => {
        setValueTypePayIn("Фиат")
    }, [variant_buttons])

    function activeCards() {
        const cardButtons = document.querySelectorAll('.card');
        let previousActiveCard = null


        for (let cardButton of cardButtons) {
            cardButton.addEventListener('click', (event) => {
                if (previousActiveCard !== null) {
                    previousActiveCard.classList.remove('active');
                }
                setChoice_payment(cardButton.getAttribute("name"))
                cardButton.classList.toggle('active');
                previousActiveCard = cardButton;

                event.stopPropagation();
            });
        }

    }

    // async function save_information_payments() {
    //     try {
    //         await UserService.change_payment_information(client_email, client_name, essential_key, promocode, Number(card_number))
    //     } catch (e) {
    //         console.error(e)
    //     }
    // }

    function handleClickDep() {
        if (Number.isNaN(amount)) {
            setError("enter_correct_sum")
            setStatusErrorChange(!statusErrorChange)

        } else if (!choice_payment) {
            setStatusErrorChange(!statusErrorChange)
            return setError("error11")


        } else {
            const dataPayment = graphPayin_methods[choice_payment];
            const params = JSON.parse(graphPayin_methods[choice_payment].params)
            let flag = true;
            console.log(dataPayment, "payment")
            for (const input of inputs_payin) {
                if (input.checkFunc) {

                    if (!input.checkFunc(graph_naming[input.value])) {

                        store.add_message(input.errorMessage, ErrorComponent)

                        flag = false;
                        break
                    }
                }

            }

            const { min, max } = params;
            if (flag) {


                if (amount < min) {
                    setError(`|error15| ${min}₽`)
                    setStatusErrorChange(!statusErrorChange)
                } else if (amount > max) {
                    setError(`|error16| ${max}₽`)
                    setStatusErrorChange(!statusErrorChange)

                } else {

                    setStatusDepButton(true);
                    if (choice_payment === "by_mobile" || choice_payment === "card_number") {

                        fetch_payport()


                    } else {
                        if (dataPayment.system === "expay") {
                            fetch_expay(dataPayment.name);
                        }
                        else {
                            fetch_fk()

                        }
                    }
                }
            }
        }
    }

    function checkName(name) {
        return name.length > 0;
    }

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    }

    function is_numeric(str) {
        return /^\d+$/.test(str);
    }

    function validateNumber(number) {
        return ((is_numeric(number)) || (number[0] === "+" && is_numeric(number.slice(1, number.length))))
    }
    async function setActiveCardCrypto(name) {
        setPayInCardCrypto(name);
        if (!cryptoData[name]) {
            try {


                setLoadingCryptoForm(true)
                console.log("true")
                const data = new FormData();
                data.append("user_id", store.user.id)
                data.append("crypto_code", name)
                data.append("type", "createCryptoCloudWallet")
                const response = await axios.post("https://snake.money/cryptoCloudAPI", data)

                const dataResponse = response.data.response.result;
                if (response.data.status === "ok") {
                    const data_new = { crypto_code: dataResponse.currency.code, name: dataResponse.currency.name, qr_code: dataResponse.currency.icon_qr, network_code: dataResponse.currency.obj_network.code, address: dataResponse.address };
                    setCryptoData_current(data_new)
                    setCryptoData((el) => {
                        const el_cur = el;
                        el_cur[data_new.crypto_code] = data_new
                        return el_cur;
                    })
                }
                else {
                    setCryptoData_current({})
                    store.add_message("error1", ErrorComponent);

                }

                setLoadingCryptoForm(false);
            }
            catch (e) {
                console.log(e)
            }
            finally {
                setLoadingCryptoForm(false);
                console.log("false")

            }

        }
        else {
            setCryptoData_current({ ...cryptoData[name], name })
        }


    }
    function setActiveCard(e, name, id, information = {}) {

        const inputs = document.querySelectorAll(".inf input");
        for (let input of inputs) {
            input.value = ""
        }
        setChoice_payment(name)

        if (name === "by_mobile") {
            setInputs_payin([{
                _placeholder: "inputs_payin1",
                state: setAmount
            }, {
                _placeholder: "inputs_payin2",
                value: "promocode",
                state: setPromocode,

                _dop_placeholder: "inputs_payin3"
            }])
            setInputs_payout([{ _placeholder: information.placeholder, state: setAmount }])
            setPurse_number("payport")
        } else if (name === "card_number") {

            setInputs_payin([{
                _placeholder: "inputs_payin1",
                state: setAmount
            }, {
                _placeholder: "inputs_payin2",
                value: "promocode",

                state: setPromocode,

                _dop_placeholder: "inputs_payin3"
            }])
            setInputs_payout([{ _placeholder: information.placeholder, state: setAmount }])

            setPurse_number("payport")
        } else {
            setInputs_payin([{ _placeholder: "inputs_payin1", state: setAmount }, {
                _placeholder: "inputs_payin2",
                value: "promocode",

                state: setPromocode,
                _dop_placeholder: "inputs_payin3"
            }])
            setInputs_payout([{ _placeholder: information.placeholder, state: setPurse_number }, {
                _placeholder: "inputs_payout2",
                state: setAmount
            }])
            setPurse_number("")


        }

        const activeCard = document.querySelector(".card.active");

        if ((information.name === "fk_sbp" && information.system === "freekassa") || (information.name === "SBPRUB" && information.system === "expay")) {
            setInputs_payout([{ _placeholder: "Выбрать банк", state: setChoice_sbp, option: true, type_option: "sbp" }, { _placeholder: information.placeholder, state: setPurse_number }, {
                _placeholder: "inputs_payout2",
                state: setAmount
            }])
        }
        if (information.name === "fk_mobile" && information.system === "freekassa") {
            setInputs_payout([{ _placeholder: "Выбрать оператора", state: setChoice_sbp, option: true, type_option: "mobile" }, { _placeholder: information.placeholder, state: setPurse_number }, {
                _placeholder: "inputs_payout2",
                state: setAmount
            }])
        }

        if (activeCard) {
            activeCard.classList.remove("active");

        }

        document.getElementById(id).classList.add("active")
        if (variant_buttons === "dep") {
            const params = JSON.parse(graphPayin_methods[name].params);
            setKomm(Number(params.fee_user * 100).toFixed(1))
            setLimits(formatCurrency(params.min, "cost") + " - " + formatCurrency(params.max, "cost"))
            setWaitTime(params.wait_time)

        } else {
            const params = JSON.parse(graphPayout_methods[name].params);
            setKomm(Number(params.fee_user * 100).toFixed(1))
            setLimits(formatCurrency(params.min, "cost") + " - " + formatCurrency(params.max, "cost"))
        }


    }

    function handleClickBack() {

        if (info_wagering.status === 0) {
            setError("Вывод не доступен")
        }
        else if (Number.isNaN(amount)) {
            setError("enter_correct_sum")
            setStatusErrorChange(!statusErrorChange)
        } else if (!choice_payment) {
            setError("error11")
            setStatusErrorChange(!statusErrorChange)
        } else {

            const maska = graphPayout_methods[choice_payment].check_maska
            const regex = new RegExp(maska);
            if (!regex.test(purse_number) && (choice_payment !== "by_mobile" && choice_payment !== "card_number")) {
                setStatusErrorChange(!statusErrorChange)
                return setError("|error13|" + graphPayout_methods[choice_payment].example)
            }
            if ((choice_payment === "fk_sbp" || choice_payment === "SBPRUB") && !choice_sbp) {
                setStatusErrorChange(!statusErrorChange)
                return setError("error12")
            }

            const params = JSON.parse(graphPayout_methods[choice_payment].params)

            const { min, max } = params;
            if (amount < min) {
                setStatusErrorChange(!statusErrorChange)
                setError(`|error17| ${min}₽`)
            } else if (amount > max) {
                setStatusErrorChange(!statusErrorChange)
                setError(`|error18| ${max}₽`)

            } else {
                if (graphPayout_methods[choice_payment].system === "expay") {
                    fetch_back_expay()
                }
                else {
                    fetch_back()
                }
            }
        }
    }



    function Change_buttons_history(name) {
        // setVariant_buttons_history(name)
        if (name === "dep") {
            getHistoryPayIn()
        }
        // else{
        //     getHistoryPayOut()
        // }
    }

    function Changevariant_buttons(target) {
        const name = target
        if (target !== "bonus") {


            setAmount(0)
            setKomm(0)
            setLimits("")
            setWaitTime(0)
            setChoice_payment("")
            setVariant_buttons_history("dep")

            // getHistoryPayIn()
            const inputs = document.querySelectorAll(".inf input");
            for (let input of inputs) {
                input.value = ""
            }
        }
        setVariant_buttons(name)
    }

    function formatDateTime(dateString) {
        const currentDate = new Date(dateString);


        // Настроить параметры для получения московского времени
        const options = {
            timeZone: 'Europe/Moscow',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        };

        // Получить форматированную дату в нужном виде
        const formatter = new Intl.DateTimeFormat('ru-RU', options);
        const formattedParts = formatter.formatToParts(currentDate);

        // Объединить части в одну строку
        let formattedDate = formattedParts.reduce((acc, part) => {
            if (part.type !== 'literal') {
                acc[part.type] = part.value;
            }
            return acc;
        }, {});

        let formattedString = `${formattedDate.year}-${formattedDate.month}-${formattedDate.day} ${formattedDate.hour}:${formattedDate.minute}:${formattedDate.second}`;

        return formattedString;

    }
    function getVerif() {
        if (store.user.status_payin === 1 || store.user.status_payout === 1 || store.user.status_verify >= 2) {


            const interval = setInterval(() => {

                const divRoot = document.getElementById("veriff-root")
                if (divRoot) {
                    console.log("ok")
                    if (!window.Veriff) {
                        console.log('Veriff SDK is not loaded');
                        return;
                    }
                    const veriff = window.Veriff({
                        host: 'https://stationapi.veriff.com',
                        apiKey: 'a1eb89b7-be9a-4404-ac11-aa5b40ef2842',
                        parentId: 'veriff-root',
                        onSession: async function (err, response) {
                            if (err) {
                                console.error('Session creation error:', err);
                                return;
                            }

                            await axios.post("https://snake.money/kyc/veriff_create", JSON.stringify(response))

                            window.veriffSDK.createVeriffFrame({ url: response.verification.url });
                        },
                    });
                    veriff.setParams({

                        vendorData: String(store.user.id)
                    });
                    veriff.mount({
                        formLabel: {
                            vendorData: "ВАШ ID",
                            givenName: "Имя",
                            lastName: "Фамилия",
                            submitBtn: "Начать верификацию"


                        },
                        loadingText: "Загрузка",
                        submitBtnText: "Начать верификацию"


                    });
                    clearInterval(interval);
                }
            }, 100)
        }





    }


    function handleChangeSelect(e) {
        setChoice_sbp(e.target.value);
    }

    if (stateText) {
        return <SpinPage />
    }
    if (!store.isLoading && !store.user.login) {
        navigate("")
    }
    if (authChecked) {
        if (store.isLoading || !loadDate) {
            return (
                <SpinPage />
            )
        }
        if (!store.isLoading && store.user.login && loadDate) {
            return (
                <>
                    <div className="payments fadeAnimationMain">

                        <div className="variant_buttons">
                            <div
                                className={`dep ${variant_buttons === 'dep' ? 'active' : ''}`}
                                onClick={e => Changevariant_buttons("dep")}
                            >
                                {store.dataLang["deposit_text1"]}
                            </div>
                            <div
                                className={`back ${variant_buttons === 'back' ? 'active' : ''}`}
                                onClick={e => Changevariant_buttons("back")}
                            >
                                {store.dataLang["deposit_text2"]}


                            </div>
                            <div
                                className={`history ${variant_buttons === 'history' ? 'active' : ''}`}
                                onClick={e => Changevariant_buttons("history")}
                            >
                                {store.dataLang["deposit_text3"]}


                            </div>
                            <div
                                className={`bonus ${variant_buttons === 'bonus' ? 'active' : ''}`}
                                onClick={e => Changevariant_buttons("bonus")}
                            >
                                {store.dataLang["money_rooms_text2"]}


                            </div>
                        </div>
                        {variant_buttons === "bonus" && (
                            <Bonuses />
                        )}


                        {variant_buttons === 'dep' && (
                            <div className='wrapper_payment_block'>

                                <div className="payment_block">

                                    <div className="wrapper_payment">

                                        {(store.user.status_payin === 0 && store.user.status_verify < 2) ? <a className="blockInfoSupport" href="https://t.me/snake_money_w">Не пришел депозит, обратитесь в поддержку <i class="fa-solid fa-envelope" style={{ marginLeft: "10px" }}></i></a> :
                                            <div className='blockInfoSupport warning' >Требуется верификация</div>
                                        }
                                        {MODE === "dev" && <div className='fade cards'><Switcher values={["Фиат", "Криптавалюта"]} onChangeState={setValueTypePayIn} /></div>}

                                        <div className="fade cards">

                                            {(store.user.status_payin === 1 || store.user.status_verify >= 2) && <div id="veriff-root"></div>}
                                            {valueTypePayIn === "Фиат" ? (store.user.status_payin === 0 && store.user.status_verify < 2) && payin_methods.map(payin_method =>
                                                <div onClick={e => setActiveCard(e, payin_method.name, payin_method.id)}
                                                    className="card" key={payin_method.id} id={payin_method.id}
                                                    name={payin_method.name}>
                                                    <div style={{ position: "absolute", top: 0, left: 0, display: "flex", gap: "5px" }}>
                                                        <div className={"block_infCard"}>{JSON.parse(payin_method.params).fee_user}%</div>
                                                        {payin_method.dop_icon && <div className={"block_infCard"} dangerouslySetInnerHTML={{ __html: payin_method.dop_icon }}></div>}
                                                    </div>
                                                    <img
                                                        loading="lazy" className="wlc-payment-list-item__image ng-star-inserted"
                                                        alt={payin_method.name} srcSet=""
                                                        src={NAME_SERVER + "/assets/" + payin_method.icon + ""} />
                                                </div>
                                            ) : (store.user.status_payin === 0 && store.user.status_verify < 2) && payin_methods_crypto.map(payin_method =>
                                                <div onClick={e => setActiveCardCrypto(payin_method.name)}
                                                    className={"card " + (payInCardCrypto === payin_method.name && "active")} key={payin_method.id} id={payin_method.id}
                                                    name={payin_method.name}>
                                                    <div style={{ position: "absolute", top: 0, left: 0, display: "flex", gap: "5px" }}>
                                                        <div className={"block_infCard"}>{JSON.parse(payin_method.params).fee_user}%</div>
                                                        {payin_method.dop_icon && <div className={"block_infCard"} dangerouslySetInnerHTML={{ __html: payin_method.dop_icon }}></div>}
                                                    </div>
                                                    <img
                                                        loading="lazy" className="wlc-payment-list-item__image ng-star-inserted"
                                                        alt={payin_method.name} srcSet=""
                                                        width={100}
                                                        height={100}
                                                        src={NAME_SERVER + "/assets/" + payin_method.icon + ""} />
                                                </div>
                                            )}


                                        </div>

                                        {(store.user.status_payin === 0 && store.user.status_verify < 2 && valueTypePayIn === "Фиат") && <div className="mainCt">
                                            <div className="inf">
                                                <form>
                                                    {inputs_payin.map((input_payin, index) => (
                                                        <div className="search_box" style={{ marginBottom: "0px !important" }}
                                                            key={index}>

                                                            {/*<label*/}
                                                            {/*    className="placeholder-label">{store.dataLang[input_payin._placeholder]}</label>*/}

                                                            <div className="search-wrapper_payment active">
                                                                <div className="input-holder pays active">
                                                                    <input
                                                                        onChange={(e) => {
                                                                            input_payin.state(e.target.value)
                                                                        }}
                                                                        style={{ color: input_payin.value === "promocode" ? "#e3b515" : "white" }}

                                                                        value={graph_naming[input_payin.value]}
                                                                        className="search-input pays active"
                                                                        placeholder={store.dataLang[input_payin._placeholder]}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </form>

                                            </div>

                                            {(choice_payment) && (

                                                <div className="wrraper_center">

                                                    <div className="comma_block"><p
                                                        className="commisia">{store.dataLang["commission_name"]} {komm}%</p>
                                                        <p className="commisia">{store.dataLang["inf_choice_pay2"]} {limits}</p>
                                                    </div>
                                                </div>)}



                                            <div className="btn">
                                                <button onClick={handleClickDep} disabled={statusDepButton}
                                                    className="buttonPlus skeleton-button">{statusDepButton ? <Spin /> : store.dataLang["deposit_button"]}
                                                </button>
                                            </div>



                                        </div>}
                                        {(store.user.status_payin === 0 && store.user.status_verify < 2 && valueTypePayIn === "Криптавалюта" && (cryptoData_current.address || loadingCryptoForm)) && <div className='mainContCrypto'>
                                            {loadingCryptoForm ? <SpinPage /> : <>
                                                <div className={"head_crypto"}>Ваш личный адрес</div>
                                                <div className='wrapper_crypto'>
                                                    <div className='blockInfCrypto'>Сеть: {cryptoData_current.network_code}</div>

                                                    <CopyToClipboard
                                                        text={cryptoData_current.address}
                                                        onCopy={() => store.add_message("Успешно скопировано", Succses)}>
                                                        <div className={stylesSetting.BlcokInf} style={{ textAlign: "center", wordBreak: "break-all", justifyContent: "center" }}>
                                                            {cryptoData_current.address}
                                                        </div>
                                                    </CopyToClipboard>

                                                    <div style={{ display: "flex", justifyContent: "center" }}><img src={cryptoData_current.qr_code} /></div>
                                                </div>

                                                <div className='blockInfCrypto'>Минимальная сумма депозита {JSON.parse((graphPayin_methods_crypto[payInCardCrypto]).params).min} {cryptoData_current.name}</div>
                                                <div className='blockInfCrypto' style={{ fontSize: "18px", color: "#f84444" }}>Отправляйте на этот адрес только {cryptoData_current.name} ({cryptoData_current.network_code}). Отправка любой другой валюты приведет к потере средств.</div>

                                            </>}

                                        </div>}




                                    </div>
                                </div>
                            </div>
                        )} {variant_buttons === 'back' && (
                            <div className='wrapper_payment_block'>
                                <div className="payment_block">
                                    <div className="wrapper_payment">
                                        {((store.user.status_payout === 1 && store.user.status_verify !== 1) && (info_wagering.status === 1 || store.user.status_verify === 2)) &&
                                            <div className='blockInfoSupport warning' >Требуется верификация</div>
                                        }
                                        <div className="fade cards">
                                            {((store.user.status_payout === 1 && store.user.status_verify !== 1) && (info_wagering.status === 1 || store.user.status_verify === 2)) && <div id="veriff-root"></div>}

                                            {(!(store.user.status_payout === 1 && store.user.status_verify !== 1) || (info_wagering.status === 0 && store.user.status_verify < 2)) && payout_methods.map(payin_method =>
                                                <div onClick={e => setActiveCard(e, payin_method.name, payin_method.id, payin_method)}
                                                    className="card" key={payin_method.id} id={payin_method.id}
                                                    name={payin_method.name}>
                                                    <div style={{ position: "absolute", top: 0, left: 0, display: "flex", gap: "5px" }}>
                                                        <div className={"block_infCard"}>{JSON.parse(payin_method.params).fee_user}%</div>
                                                        {payin_method.dop_icon && <div className={"block_infCard"} dangerouslySetInnerHTML={{ __html: payin_method.dop_icon }}></div>}
                                                    </div>
                                                    <img onClick={e => setActiveCard(e, payin_method.name, payin_method.id, payin_method)}
                                                        loading="lazy" className="wlc-payment-list-item__image ng-star-inserted"
                                                        alt={payin_method.name} srcSet=""
                                                        src={NAME_SERVER + "/assets/" + payin_method.icon + ""} />
                                                </div>
                                            )}


                                        </div>


                                        {(info_wagering.status === 0 && store.user.status_verify < 2) ? <div className="contianer_info_wagering fade">
                                            <InfoWagering props={info_wagering} />

                                        </div> : (!(store.user.status_payout === 1 && store.user.status_verify !== 1)) && <div className="mainCt">
                                            <div className="inf">
                                                {inputs_payout.map((input_payout, index) => (
                                                    <div className="search_box" style={{ marginBottom: "0px !important" }}
                                                        key={index}>

                                                        {/*<label*/}
                                                        {/*    className="placeholder-label">{store.dataLang[input_payin._placeholder]}</label>*/}

                                                        <div className="search-wrapper_payment active">
                                                            {input_payout.option ?
                                                                get_data_lists(input_payout, input_payout.type_option)
                                                                : <div className="input-holder pays active"><input
                                                                    onChange={(e) => input_payout.state(e.target.value)}
                                                                    className="search-input pays active"
                                                                    placeholder={store.dataLang[input_payout._placeholder] ? store.dataLang[input_payout._placeholder] : input_payout._placeholder}
                                                                /></div>}






                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                            {choice_payment && (
                                                <div className="wrraper_center">


                                                    <div className="comma_block">
                                                        <p className="commisia">{store.dataLang["commission_name"]} {komm}%</p>
                                                        <p className="commisia">{store.dataLang["inf_choice_pay2"]} {limits}</p>
                                                    </div>
                                                </div>
                                            )}


                                            <div className="btn">
                                                <button onClick={handleClickBack} className="buttonPlus skeleton-button" style={{ opacity: info_wagering.status === 0 ? 0.7 : 1 }}
                                                    disabled={disable_btn || (info_wagering.status === 0)}>{store.dataLang["deposit_text2"]}
                                                </button>

                                            </div>
                                        </div>}

                                    </div>
                                </div>
                            </div>

                        )}


                        {variant_buttons === "history" && (
                            <div className="mainCtTable">
                                <div className="variant_buttons_history">
                                    <div
                                        className={`dep ${variant_buttons_history === 'dep' ? 'active' : ''}`}
                                        onClick={() => {
                                            getHistoryPayIn()
                                            setVariant_buttons_history("dep")
                                        }}
                                    // onClick={Change_buttons_history("dep")}
                                    >
                                        {store.dataLang["table_header1"]}
                                    </div>
                                    <div className={`back ${variant_buttons_history === 'back' ? 'active' : ''}`}
                                        onClick={() => {
                                            getHistoryPayOut()
                                            setVariant_buttons_history("back")
                                        }}
                                    >
                                        {store.dataLang["table_header2"]}
                                    </div>
                                </div>
                                <table className={`history ${loadingHistory ? "fade_history" : ""}`}>
                                    <thead>
                                        <tr>
                                            <th>{store.dataLang["table_th1"]}</th>
                                            <th>{store.dataLang["table_th2"]}</th>
                                            <th>{store.dataLang["table_th3"]}</th>
                                            <th>{store.dataLang["table_th4"]}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            history_payinWar_loading.map(data =>
                                                <tr className={"fade"} key={data.id}>
                                                    <CopyToClipboard
                                                        text={data.id}
                                                        onCopy={() => store.add_message("Успешно скопировано", Succses)}>
                                                        <td style={{ fontSize: (String(data.id).length <= 10) ? "15px" : "10px" }} className='order_id'>{data.id}</td>

                                                    </CopyToClipboard>
                                                    <td className="balanceRoom">
                                                        <span>{formatCurrency(data.amount ? data.amount : data.amount_currency)}</span>
                                                    </td>
                                                    <td>{formatDateTime(data.date_create)}</td>
                                                    <td className={"history_td"}>
                                                        <p className={"loadp"}>{store.dataLang["status1"]} <i
                                                            className="fa-solid fa-sync fa-spin"></i>

                                                        </p>

                                                    </td>
                                                </tr>
                                            )}
                                        {history_payinSuccses.map(data =>
                                            <tr className={"fade"} key={data.id}>
                                                <CopyToClipboard
                                                    text={data.id}
                                                    onCopy={() => store.add_message("Успешно скопировано", Succses)}>
                                                    <td style={{ fontSize: ((String(data.id).length) <= 10) ? "15px" : "10px" }} className='order_id'>{data.id}</td>

                                                </CopyToClipboard>
                                                <td className="balanceRoom"><span>{formatCurrency(data.amount)}</span></td>
                                                <td>{formatDateTime(data.date)}</td>
                                                <td className={"history_td"}>
                                                    <p className={"loadp"} style={{
                                                        textAlign: "center",
                                                        fontSize: "22px"
                                                    }}>{store.dataLang["status2"]} <i
                                                        className="start-icon far fa-check-circle faa-tada succsesIcon animated"></i>
                                                    </p>
                                                </td>
                                            </tr>
                                        )}
                                        {history_payinWar_cancel.map(data =>
                                            <tr key={data.id}>
                                                <CopyToClipboard
                                                    text={data.id}
                                                    onCopy={() => store.add_message("Успешно скопировано", Succses)}>
                                                    <td style={{ fontSize: (String(data.id)).length <= 10 ? "15px" : "10px" }} className='order_id'>{data.id}</td>

                                                </CopyToClipboard>
                                                <td className="balanceRoom">
                                                    <span>{formatCurrency(data.amount ? data.amount : data.amount_currency)}</span>
                                                </td>
                                                <td>{formatDateTime(data.date_create)}</td>
                                                <td className={"history_td"}>
                                                    {data.status > 3 ? (
                                                        <p className={"loadp"} style={{
                                                            textAlign: "center",
                                                            fontSize: "22px"
                                                        }}>{store.dataLang["status3"]}<i style={{ marginLeft: "10px" }}
                                                            className="start-icon far fa-times-circle faa-tada animated dangerIcon"></i>

                                                        </p>
                                                    ) : (
                                                        <p className={"loadp"} style={{
                                                            textAlign: "center",
                                                            fontSize: "22px"
                                                        }}>{store.dataLang["status4"]}<i style={{ marginLeft: "10px" }}
                                                            className="start-icon far fa-times-circle faa-tada animated dangerIcon"></i>
                                                        </p>
                                                    )}


                                                </td>
                                            </tr>
                                        )}


                                    </tbody>
                                </table>
                            </div>
                        )}


                    </div>
                    <Footer />
                </>


            );
        }
        if (!store.isLoading && !store.user.login) {
            navigate("")
        }
    }

};

export default observer(Deposit);